<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>雨区淤地坝统计</p>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">省市县数量分布
          <el-button size="mini" round @click="bigdialogClick('ybssx')">大图</el-button>
        </p>
        <div class="Piebar">
          <div class="Piebar" id="ssxbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">按病险坝统计
          <el-button size="mini" round @click="bigdialogClick('ybbxb')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="bxbAll!=0" style="margin-top: 30px;">总和：{{bxbAll}}</span>
          <div class="Piebar" id="bxbbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">按流域统计
          <el-button size="mini" round @click="bigdialogClick('ybliuyu')">大图</el-button>
        </p>
        <div class="Piebar">
          <div class="Piebar" id="liuyubar"></div>
        </div>
      </div>
      <div class="contents">
        <p></p>
        <p class="title1">按老旧坝统计
          <el-button size="mini" round @click="bigdialogClick('ybljb')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="ljbAll!=0" style="margin-top: 30px;">总和：{{ljbAll}}</span>
          <div class="Piebar" id="ljbbar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //5.21
  selectshengshixianCount,
  selectSSLYSum,
  selectBXLJBCount,
  selectBXLJBCountB
} from "@/api/api.js";
export default {
  props: ['bzswitchClick'],
  data() {
    return {
      show: false,

      ssxbar: null,
      liuyubar: null,
      bxbbar: null,
      ljbbar: null,

      bxbAll: 0,//病险坝统计总和
      ljbAll: 0,//老旧坝统计总和

      ssxCityName: [],
      shengCount: 0,
      shiCount: 0,
      xianCount: 0,

      lyCityName: [],
      ydbsszlSum: [],

      bxbCityName: [],
      bxbCityId: [],
      bxbDxbNum: [],
      bxbZxbNum: [],
      bxbDxbYrNum: [],
      bxbZxbYrNum: [],

      ljbCityName: [],
      ljbCityId: [],
      ljbDxbNum: [],
      ljbZxbNum: [],
      ljbDxbYrNum: [],
      ljbZxbYrNum: [],

      ydbCodeLists: null,
      value: false,
    };
  },
  mounted() {
    let params = {
      regionCode: this.$store.state.nowxingzhengCode,
      yuShi: this.$store.state.yuShi
    };
    //获取雨区省市县分布
    this.ydbtotalForssx(params);
    //获取淤地坝数量统计按流域
    this.ydbtotalForliuyu(params);
    //获取淤地坝数量统计按病险坝
    this.ydbtotalForBxbNew(params);
    //获取淤地坝数量统计按老旧坝
    this.ydbtotalForLjbNew(params);
  },
  computed: {
    nowxingzhengCodes() {
      return this.$store.state.nowxingzhengCode; //需要监听的数据
    },
    myydbDataFuns() {
      return this.$store.state.myydbData; //需要监听的数据
    },
    yuShiFuns() {
      return this.$store.state.yuShi; //需要监听的数据
    },
  },
  watch: {
    bzswitchClick(newVal, oldVal) {
      this.bxbAll = 0;
      this.ljbAll = 0;
      this.value = newVal;
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        ydbCodeList: this.$store.state.myydbData,
        yuShi: this.$store.state.yuShi
      };
      //获取雨区省市县分布
      // this.ydbtotalForssx(params);
      //获取淤地坝数量统计按流域
      // this.ydbtotalForliuyu(params);
      if (newVal == false) {//饼图
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxbNew(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjbNew(params);
      } else {//柱图
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxb(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjb(params);
      }
    },

    nowxingzhengCodes(newVal, oldVal) {
      // if (oldVal) {
      let params;
      if (this.$store.state.ydbryorssShow == false) {
        params = {
          regionCode: newVal,
          yuShi: this.$store.state.yuShi
        };
      } else {
        params = {
          regionCode: newVal,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: this.$store.state.yuShi
        };
      }
      //获取雨区省市县分布
      this.ydbtotalForssx(params);
      //获取淤地坝数量统计按流域
      this.ydbtotalForliuyu(params);
      if (this.value == false) {
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxbNew(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjbNew(params);
      } else {
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxb(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjb(params);
      }
      // }
    },
    myydbDataFuns(newVal, oldVal) {
      if (oldVal != null) {
        let params;
        this.ydbCodeLists = newVal;
        if (this.$store.state.ydbryorssShow == false && this.$store.state.kxcxStatus == false && this.$store.state
          .dzmcxStatus == false && this.$store.state.dtjcxStatus == false) {
          params = {
            regionCode: this.$store.state.nowxingzhengCode,
            yuShi: this.$store.state.yuShi
          };
        } else {
          params = {
            regionCode: this.$store.state.nowxingzhengCode,
            ydbCodeList: newVal,
            yuShi: this.$store.state.yuShi
          };
        }

        //获取雨区省市县分布
        this.ydbtotalForssx(params);
        //获取淤地坝数量统计按流域
        this.ydbtotalForliuyu(params);
        if (this.value == false) {
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxbNew(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjbNew(params);
        } else {
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxb(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjb(params);
        }
      }
    },
    yuShiFuns(newVal, oldVal) {
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        ydbCodeList: this.$store.state.myydbData,
        yuShi: newVal
      };
      //获取雨区省市县分布
      this.ydbtotalForssx(params);
      //获取淤地坝数量统计按流域
      this.ydbtotalForliuyu(params);
      if (this.value == false) {
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxbNew(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjbNew(params);
      } else {
        //获取淤地坝数量统计按病险坝
        this.ydbtotalForBxb(params);
        //获取淤地坝数量统计按老旧坝
        this.ydbtotalForLjb(params);
      }
    },
  },
  methods: {
    //大图点击事件
    bigdialogClick(type) {
      let echartsData = {};
      echartsData.type = type;
      echartsData.isBar = this.value;
      if (type == 'ybssx') {
        echartsData.title = '省市县数量分布';
        echartsData.ssxCityName = this.ssxCityName;
        echartsData.shengCount = this.shengCount;
        echartsData.shiCount = this.shiCount;
        echartsData.xianCount = this.xianCount;
      } else if (type == 'ybliuyu') {
        echartsData.title = '按流域统计';
      } else if (type == 'ybbxb') {
        echartsData.title = '按病险坝统计';
        echartsData.bxbCityName = this.bxbCityName;
        echartsData.bxbCityId = this.bxbCityId;
        echartsData.bxbDxbNum = this.bxbDxbNum;
        echartsData.bxbZxbNum = this.bxbZxbNum;
        echartsData.bxbDxbYrNum = this.bxbDxbYrNum;
        echartsData.bxbZxbYrNum = this.bxbZxbYrNum;
      } else if (type == 'ybljb') {
        echartsData.title = '按老旧坝统计';
        echartsData.ljbCityName = this.ljbCityName;
        echartsData.ljbCityId = this.ljbCityId;
        echartsData.ljbDxbNum = this.ljbDxbNum;
        echartsData.ljbZxbNum = this.ljbZxbNum;
        echartsData.ljbDxbYrNum = this.ljbDxbYrNum;
        echartsData.ljbZxbYrNum = this.ljbZxbYrNum;
      }
      this.$emit("bigDialogData", echartsData);
    },

    //获取雨区省市县分布饼图
    ydbtotalForssx(params) {
      this.ssxCityName = '雨区';
      this.shengCount = 0;
      this.shiCount = 0;
      this.xianCount = 0;
      selectshengshixianCount(params).then((res) => {
        this.shengCount = res.data[0].shengCount;
        this.shiCount = res.data[0].shiCount;
        this.xianCount = res.data[0].xianCount;
        this.ssxbars(this.ssxCityName, this.shengCount, this.shiCount, this.xianCount);
      });
    },

    //流域统计柱图
    ydbtotalForliuyu(params) {
      this.lyCityName = [];
      this.ydbsszlSum = [];
      selectSSLYSum(params).then((res) => {
        // console.log(res)
        for (let i = 0; i < res.data.length; i++) {
          this.lyCityName.push(res.data[i].ydbSszl);
          this.ydbsszlSum.push(res.data[i].ydbsszlSum);
          this.lybar(this.lyCityName, this.ydbsszlSum);
        }
      });
    },

    //获取淤地坝数量统计按病险坝柱图
    ydbtotalForBxb(params) {
      this.bxbCityName = [];
      this.bxbCityId = [];
      this.bxbDxbNum = [];
      this.bxbZxbNum = [];
      this.bxbDxbYrNum = [];
      this.bxbZxbYrNum = [];
      selectBXLJBCount(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          this.bxbCityName.push(res.data[i].addressName);
          this.bxbCityId.push({
            code: res.data[i].addressCode,
            name: res.data[i].addressName
          });
          this.bxbDxbNum.push(Number(res.data[i].dxbxbSum));
          this.bxbZxbNum.push(Number(res.data[i].zxbxbSum));
          this.bxbDxbYrNum.push(Number(res.data[i].dxyrbxbSum));
          this.bxbZxbYrNum.push(Number(res.data[i].zxyrbxbSum));
        }
        this.bxbbars(this.bxbCityId, this.bxbCityName, this.bxbDxbNum, this.bxbZxbNum, this.bxbDxbYrNum, this.bxbZxbYrNum);
      });
    },

    //获取淤地坝数量统计按病险坝饼图
    ydbtotalForBxbNew(params) {
      this.bxbCityName = '全部地区';
      this.bxbDxbNum = 0;
      this.bxbZxbNum = 0;
      this.bxbDxbYrNum = 0;
      this.bxbZxbYrNum = 0;
      selectBXLJBCountB(params).then((res) => {
        // console.log(res)
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].ydbbx == '大型') {
            this.bxbDxbNum = Number(res.data[i].bxbSum);
            this.bxbDxbYrNum = Number(res.data[i].yrbxbSum);
          } else if (res.data[i].ydbbx == '中型') {
            this.bxbZxbNum = Number(res.data[i].bxbSum);
            this.bxbZxbYrNum = Number(res.data[i].yrbxbSum);
          }
        }
        this.bxbbarNew(this.bxbCityName, this.bxbDxbNum, this.bxbZxbNum, this.bxbDxbYrNum, this.bxbZxbYrNum);
      });
    },

    //获取淤地坝数量统计按老旧坝柱图
    ydbtotalForLjb(params) {
      this.ljbCityName = [];
      this.ljbCityId = [];
      this.ljbDxbNum = [];
      this.ljbZxbNum = [];
      this.ljbDxbYrNum = [];
      this.ljbZxbYrNum = [];
      selectBXLJBCount(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          this.ljbCityName.push(res.data[i].addressName);
          this.ljbCityId.push({
            code: res.data[i].addressCode,
            name: res.data[i].addressName
          });
          this.ljbDxbNum.push(Number(res.data[i].dxljbSum));
          this.ljbZxbNum.push(Number(res.data[i].zxljbSum));
          this.ljbDxbYrNum.push(Number(res.data[i].dxyrljbSum));
          this.ljbZxbYrNum.push(Number(res.data[i].zxyrljbSum));
        }
        this.ljbbars(this.ljbCityId, this.ljbCityName, this.ljbDxbNum, this.ljbZxbNum, this.ljbDxbYrNum, this.ljbZxbYrNum);
      });
    },

    //获取淤地坝数量统计按老旧坝饼图
    ydbtotalForLjbNew(params) {
      this.ljbCityName = '全部地区';
      this.ljbDxbNum = 0;
      this.ljbZxbNum = 0;
      this.ljbDxbYrNum = 0;
      this.ljbZxbYrNum = 0;
      selectBXLJBCountB(params).then((res) => {
        // console.log(res)
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].ydbbx == '大型') {
            this.ljbDxbNum = Number(res.data[i].ljbSum);
            this.ljbDxbYrNum = Number(res.data[i].yrljbSum);
          } else if (res.data[i].ydbbx == '中型') {
            this.ljbZxbNum = Number(res.data[i].ljbSum);
            this.ljbZxbYrNum = Number(res.data[i].yrljbSum);
          }
        }
        this.ljbbarNew(this.ljbCityName, this.ljbDxbNum, this.ljbZxbNum, this.ljbDxbYrNum, this.ljbZxbYrNum);
      });
    },

    //获取雨区省市县分布饼图
    ssxbars(ssxCityName, shengCount, shiCount, xianCount) {
      let _this = this;
      this.ssxbar = this.$echarts.init(document.getElementById("ssxbar"));

      // 点击图标
      // this.ssxbar.on('click', function(value) {
      //   // 全部省份的不能点击
      //     let currentObj = [{
      //       code: '',
      //       sectionName: value.data.name
      //     }]
      //     _this.$emit("ClickNames", currentObj);
      //     _this.$emit("DialogVisibles", true);
      //     _this.$emit("cxDialogVisibles", false);
      // });
      let option = {
        legend: {
          left: 'center',
          top: 5,
          data: [{ name: "省" }, { name: "市" }, { name: "县" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: ssxCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: shengCount, name: "省", itemStyle: { color: '#FFE557' } },
              { value: shiCount, name: "市", itemStyle: { color: '#1CEA58' } },
              { value: xianCount, name: "县", itemStyle: { color: '#00B3FE' } },
            ]
          },
        ]
      };
      this.ssxbar.clear();
      this.ssxbar.setOption(option);
    },

    //流域统计柱图
    lybar(lyCityName, ydbsszlSum) {
      let _this = this;
      this.liuyubar = this.$echarts.init(document.getElementById("liuyubar"));

      this.liuyubar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < lyCityName.length; i++) {
          if (value.name == lyCityName[i].name) {
            currentObject.push({
              code: lyCityName[i],
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['淤地坝数量'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: lyCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 5, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [
          {
            name: '淤地坝数量',
            type: 'bar',
            barWidth: "8px",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#FFE557",
                },
                {
                  offset: 1,
                  color: "#FFE557",
                },
                ]),
                // barBorderRadius: 5,
              }
            },
            data: ydbsszlSum
          },
        ]
      };
      this.liuyubar.clear();
      this.liuyubar.setOption(option);
    },

    //病险坝统计柱图
    bxbbars(bxbCityId, bxbCityName, bxbDxbNum, bxbZxbNum, bxbDxbYrNum, bxbZxbYrNum) {
      let _this = this;
      this.bxbbar = this.$echarts.init(document.getElementById("bxbbar"));
      this.bxbbar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < bxbCityId.length; i++) {
          if (value.name == bxbCityId[i].name) {
            currentObject.push({
              code: bxbCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['大型坝', '中型坝', '大型有人坝', '中型有人坝'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: bxbCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 30, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [{
          name: '大型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFE557 ",
              },
              {
                offset: 1,
                color: "#FFE557",
              },
              ]),
              // barBorderRadius: 12,
            },
          },
          data: bxbDxbNum
        },
        {
          name: '中型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#1CEA58",
              },
              {
                offset: 1,
                color: "#1CEA58",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: bxbZxbNum
        },
        {
          name: '大型有人坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#00B3FE ",
              },
              {
                offset: 1,
                color: "#00B3FE",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: bxbDxbYrNum
        },
        {
          name: '中型有人坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#B32EFF ",
              },
              {
                offset: 1,
                color: "#B32EFF",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: bxbZxbYrNum
        },
        ]
      };
      this.bxbbar.clear();
      this.bxbbar.setOption(option);
    },

    //病险坝统计饼图
    bxbbarNew(bxbCityName, bxbDxbNum, bxbZxbNum, bxbDxbYrNum, bxbZxbYrNum) {
      let _this = this;
      this.bxbbar = this.$echarts.init(document.getElementById("bxbbar"));
      this.bxbAll = Number(bxbDxbNum) + Number(bxbZxbNum);
      this.bxbbar.on('click', function (value) {
        let bx, sfyr;
        if (value.name == '大型坝') {
          bx = '大型';
        } else if (value.name == '中型坝') {
          bx = '中型';
        } else if (value.name == '大型有人坝') {
          bx = '大型';
          sfyr = 1;
        } else {
          bx = '中型';
          sfyr = 1;
        }
        let currentObject = [];
        currentObject.push({
          regionCode: _this.$store.state.nowxingzhengCode,
          yuShi: _this.$store.state.yuShi,
          sfyr: sfyr,
          bx: bx,
          bxlj: 'bx'
        });
        _this.$emit("ClickNames", currentObject);
      });

      let option = {
        legend: {
          left: 'right',
          top: 5,
          data: [{ name: "大型坝" }, { name: "中型坝" }, { name: "大型有人坝" }, { name: "中型有人坝" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: bxbCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: bxbDxbNum, name: "大型坝", itemStyle: { color: '#FFE557' } },
              { value: bxbZxbNum, name: "中型坝", itemStyle: { color: '#1CEA58' } },
              { value: bxbDxbYrNum, name: "大型有人坝", itemStyle: { color: '#00B3FE' } },
              { value: bxbZxbYrNum, name: "中型有人坝", itemStyle: { color: '#B32EFF' } },
            ]
          },
        ]
      };
      this.bxbbar.clear();
      this.bxbbar.setOption(option);
    },

    //老旧坝统计柱图
    ljbbars(ljbCityId, ljbCityName, ljbDxbNum, ljbZxbNum, ljbDxbYrNum, ljbZxbYrNum) {
      let _this = this;
      this.ljbbar = this.$echarts.init(document.getElementById("ljbbar"));
      this.ljbbar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < ljbCityId.length; i++) {
          if (value.name == ljbCityId[i].name) {
            currentObject.push({
              code: ljbCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['大型坝', '中型坝', '大型有人坝', '中型有人坝'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: ljbCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 30, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [{
          name: '大型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFE557 ",
              },
              {
                offset: 1,
                color: "#FFE557",
              },
              ]),
              // barBorderRadius: 12,
            },
          },
          data: ljbDxbNum
        },
        {
          name: '中型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#1CEA58",
              },
              {
                offset: 1,
                color: "#1CEA58",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: ljbZxbNum
        },
        {
          name: '大型有人坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#00B3FE ",
              },
              {
                offset: 1,
                color: "#00B3FE",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: ljbDxbYrNum
        },
        {
          name: '中型有人坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#B32EFF ",
              },
              {
                offset: 1,
                color: "#B32EFF",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: ljbZxbYrNum
        },
        ]
      };
      this.ljbbar.clear();
      this.ljbbar.setOption(option);
    },

    //老旧坝统计饼图
    ljbbarNew(ljbCityName, ljbDxbNum, ljbZxbNum, ljbDxbYrNum, ljbZxbYrNum) {
      let _this = this;
      this.ljbbar = this.$echarts.init(document.getElementById("ljbbar"));
      this.ljbAll = Number(ljbDxbNum) + Number(ljbZxbNum);
      this.ljbbar.on('click', function (value) {
        let bx, sfyr;
        if (value.name == '大型坝') {
          bx = '大型';
        } else if (value.name == '中型坝') {
          bx = '中型';
        } else if (value.name == '大型有人坝') {
          bx = '大型';
          sfyr = 1;
        } else {
          bx = '中型';
          sfyr = 1;
        }
        let currentObject = [];
        currentObject.push({
          regionCode: _this.$store.state.nowxingzhengCode,
          yuShi: _this.$store.state.yuShi,
          sfyr: sfyr,
          bx: bx,
          bxlj: 'lj'
        });
        _this.$emit("ClickNames", currentObject);
      });

      let option = {
        legend: {
          left: 'right',
          top: 5,
          data: [{ name: "大型坝" }, { name: "中型坝" }, { name: "大型有人坝" }, { name: "中型有人坝" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: ljbCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: ljbDxbNum, name: "大型坝", itemStyle: { color: '#FFE557' } },
              { value: ljbZxbNum, name: "中型坝", itemStyle: { color: '#1CEA58' } },
              { value: ljbDxbYrNum, name: "大型有人坝", itemStyle: { color: '#00B3FE' } },
              { value: ljbZxbYrNum, name: "中型有人坝", itemStyle: { color: '#B32EFF' } },
            ]
          },
        ]
      };
      this.ljbbar.clear();
      this.ljbbar.setOption(option);
    },

    Cancel() {
      this.DialogVisible = false;
    },
  },
};
</script>

<style scoped>
.totalPie {
  /* width: 100%; */
  width: calc(100% + 4px);
  height: 1100px;
  background: url(../../common/images/dbg.png) no-repeat center;
  background-size: 100% 100%;
}

.contents {
  width: 96%;
  height: 23.5%;
  margin-left: 2%;
  margin-top: 1%;
}

.contents p:nth-child(1) {
  float: left;
  width: 6px;
  height: 6px;
  margin: 12px 5px 12px 10px;
  background-color: #00b3fe;
}

.boderBottom {
  border-bottom: 1px dotted #ccc;
}

.title1 {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #00b3fe;
}

.Piebar {
  width: 100%;
  height: 220px;
}

.Piebar > span {
  float: left;
  margin-top: 5px;
  margin-left: 10px;
  color: #fff;
  font-size: 14px;
}

>>> .el-button--mini,
.el-button--mini.is-round {
  padding: 3px 10px;
  background: transparent;
  color: #fff;
  border: 1px solid #409eff;
}
</style>
